const initRelatedBlogPosts = () => {
    const blogPostsContainer = document.querySelector('blog-posts[data-blog-tags]');
    if (!blogPostsContainer) return;

    const {
        blogTags,
        shopDomain,
        showCategory,
        showDate,
        showExcerpt,
        showReadMore,
        allowedCategories,
        languageCode,
        readMoreText
    } = blogPostsContainer.dataset;

    if (!blogTags || !shopDomain || !languageCode) {
        console.warn('Required data (tags, domain, or language code) is missing.');
        return;
    }

    const predefinedCategories = allowedCategories ? allowedCategories.split(',').map(c => c.trim()) : [];
    const loadMoreContainer = document.getElementById('load-more-container');
    const loadMoreBtn = document.getElementById('load-more-btn');

    let nextCursor = null;
    let hasNextPage = true;
    let isLoading = false;

    const fetchArticles = async (afterCursor = null) => {
        if (isLoading) return;
        isLoading = true;

        const storefrontAccessToken = 'a3bbfffa7bd9c12567ca998d55f71454';
        const apiVersion = '2025-10';
        const storefrontApiUrl = `https://${shopDomain}/api/${apiVersion}/graphql.json`;
        const queryTags = blogTags.split(',').map(tag => `tag:"${tag.trim()}"`).join(' OR ');

        const query = `
            query getArticlesByTags($query: String!, $language: LanguageCode!, $after: String) @inContext(language: $language) {
                articles(
                    first: 6,
                    query: $query,
                    sortKey: PUBLISHED_AT,
                    reverse: true,
                    after: $after
                ) {
                    edges {
                        cursor,
                        node {
                            title, handle, tags, excerpt(truncateAt: 200), publishedAt, onlineStoreUrl,
                            image { url, altText, width, height },
                            blog { handle }
                        }
                    }
                    pageInfo {
                        hasNextPage
                    }
                }
            }
        `;

        try {
            const response = await fetch(storefrontApiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({
                query,
                variables: {
                    query: queryTags,
                    language: languageCode.toUpperCase(),
                    after: afterCursor
                }
            }),
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const { data } = await response.json();
            const articles = data.articles?.edges;
            const pageInfo = data.articles?.pageInfo;

            if (articles && articles.length > 0) {
                const articlesHtml = articles.map(({ node }, index) => {
                    const loadingStrategy = index < 3 ? 'eager' : 'lazy';
                    const imageHtml = node.image ? `<a href="${node.onlineStoreUrl}" class="overflow-hidden"><img src="${node.image.url}" alt="${node.image.altText || ''}" width="${node.image.width}" height="${node.image.height}" loading="${loadingStrategy}" class="blog-post-card__image w-full zoom-image group-hover:zoom"></a>` : '';

                    let categoryHtml = '';
                    if (showCategory === 'true' && node.tags.length > 0 && predefinedCategories.length > 0) {
                        for (const predefinedCategory of predefinedCategories) {
                            if (node.tags.includes(predefinedCategory)) {
                                const categoryHandle = predefinedCategory.replace(/\s+/g, '-').toLowerCase();
                                categoryHtml += `<a href="/${languageCode}/blogs/${node.blog.handle}/tagged/${categoryHandle}" class="blog-post-card__category h6 link-faded">${predefinedCategory}</a>`;
                            }
                        }
                    }

                    let dateHtml = '';
                    if (showDate === 'true') {
                        const date = new Date(node.publishedAt);
                        const formattedDate = date.toLocaleDateString(languageCode, { year: 'numeric', month: 'long', day: 'numeric' });
                        dateHtml = `<span class="h6 text-subdued"><time datetime="${node.publishedAt}">${formattedDate}</time></span>`;
                    }

                    const metaHtml = categoryHtml + dateHtml;
                    const metaBlockHtml = metaHtml !== '' ? `<div class="blog-post-card__meta">${metaHtml}</div>` : '';
                    const excerptHtml = showExcerpt === 'true' && node.excerpt ? `<p class="blog-post-card__excerpt">${node.excerpt}</p>` : '';
                    const readMoreHtml = showReadMore === 'true' ? `<a href="${node.onlineStoreUrl}" class="blog-post-card__read-more link">${readMoreText}</a>` : '';

                    return `
                    <div class="blog-post-card group snap-center">
                        ${imageHtml}
                        <div class="blog-post-card__info">
                        ${metaBlockHtml}
                        <p>
                            <a href="${node.onlineStoreUrl}" class="blog-post-card__title h4">${node.title}</a>
                        </p>
                        ${excerptHtml}
                        ${readMoreHtml}
                        </div>
                    </div>
                    `;
                }).join('');

                blogPostsContainer.insertAdjacentHTML('beforeend', articlesHtml);

                hasNextPage = pageInfo.hasNextPage;
                if (hasNextPage) {
                    nextCursor = articles[articles.length - 1].cursor;
                    if(loadMoreContainer) loadMoreContainer.style.display = 'block';
                } else {
                    if(loadMoreContainer) loadMoreContainer.style.display = 'none';
                }
            }
        } catch (error) {
            console.error('Error fetching blog articles:', error);
        } finally {
            isLoading = false;
        }
    };

    if(loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            if (hasNextPage && nextCursor && !isLoading) {
                fetchArticles(nextCursor);
            }
        });
    }

    fetchArticles();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedBlogPosts);
} else {
    initRelatedBlogPosts();
}
